import React, { useState, useEffect } from 'react'
import { db } from '../../../firebase';
import Swal from 'sweetalert2';

import Paper from '@material-ui/core/Paper';
import { Fade } from '@material-ui/core';






const ReviewForm = (props) => {


    const getDate = () => {

        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        today = mm + '/' + dd + '/' + yyyy;
        return today
    }
    const intialStateValues = {
        customerEmail: '',
        customerLocation: '',
        customerName: '',
        description: '',
        responses: [],
        date: ''
    }

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 1500
    });

    const [values, setValues] = useState(intialStateValues);

    const handleInputChange = e => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    }






    const handlerSubmit = e => {
        e.preventDefault();
        props.addOrEditLink(values);
        setValues({ ...intialStateValues })
    }


    const getLinkById = async (id) => {
        const doc = await db.collection('reviews').doc(id).get();
        console.log(doc.data())
        setValues({ ...doc.data() })
    }

    useEffect(() => {
        if (props.currentId === '') {
            setValues({ ...intialStateValues });
        } else {
            getLinkById(props.currentId);
        }



    }, [props.currentId])

    return (

        <Fade in={true}>

            <Paper elevation={0}>

                <form className='card card-body' onSubmit={handlerSubmit}>
                    <div className='form-group input-group mb-2'>
                        <div className='input-group-text bg-light'>

                            <i className='material-icons'>perm_identity</i>
                        </div>
                        <input disabled placeholder='Customer Email' onChange={handleInputChange} value={values.customerEmail} name='customerEmail' type="text" className='form-control' />
                    </div>


                    <div className="form-group input-group mb-2">
                        <div className="input-group-text bg-light">
                            <i className='material-icons'>location_on</i>
                        </div>
                        <input disabled placeholder='Customer Location' onChange={handleInputChange} value={values.customerLocation} type="text" className='form-control' name="customerLocation" id="" />
                    </div>

                    <div className="form-group mb-2">
                        <textarea onChange={handleInputChange} value={values.customerName} name="customerName"
                            disabled cols="30" placeholder='Customer name' rows="3"
                            className='form-control mb-2'></textarea>
                    </div>


                    <div className="form-group mb-2">
                        <textarea onChange={handleInputChange} value={values.projectDescription} name="projectDescription"
                            disabled cols="30" placeholder='Review' rows="3"
                            className='form-control mb-2'></textarea>
                    </div>



                    <div className="form-group mb-2">
                        <span>When this review was made</span>
                        <input disabled onChange={handleInputChange} value={values.dateEvent} className="form-control mb-2" type="text" name="dateEvent" />
                    </div>


                    <div className="form-group mb-2">
                        <textarea onChange={handleInputChange} value={values.responses} name="responses"
                            cols="30" placeholder='Review response' rows="3"
                            className='form-control mb-2'></textarea>
                    </div>

                    <button className='btn btn-primary btn-block'>
                        {props.currentId === '' ? 'Send' : 'Update'}
                    </button>
                </form>
            </Paper>
        </Fade>
    )
}

export default ReviewForm;